import React from "react";
import BreadcrumbsComponent from "../../common/BreadcrumbsComponent";
import { Link } from "react-router-dom";

const FormControls: React.FC = () => {
  const breadcrumbLinks = [{ to: `/settings`, label: "Settings" }];

  return (
    <>
      <div className="container app-record-page">
        <BreadcrumbsComponent links={breadcrumbLinks} leaf="Form Controls" />
        <div className="py-1">
          <div className="settings-list-integrations">
            <div className="page-title">Form Controls</div>
            <div className="p-3 mt-3">
              <ul className="list-group">
                <li className="list-group-item d-flex justify-content-between align-items-start">
                  <div className="ms-2 me-auto">
                    <div className="fw-bold">
                      <Link
                        to="/settings/form-inputs"
                        className="text-decoration-none"
                      >
                        Form Inputs
                      </Link>
                    </div>
                    Create and manage form inputs.
                  </div>
                </li>
                <li className="list-group-item d-flex justify-content-between align-items-start">
                  <div className="ms-2 me-auto">
                    <div className="fw-bold">
                      <Link
                        to="/settings/form-dropdowns"
                        className="text-decoration-none"
                      >
                        Form Dropdowns
                      </Link>
                    </div>
                    Create and manage form dropdowns.
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormControls;
